module.exports = __webpack_public_path__ + "img/order_user_up.36b28b95.jpg";